export default __webpack_public_path__ + "static/media/Add_Dark2.7b790d13.svg";